import { useState } from 'react';
import { Button, Form, Input, App as AntdApp } from 'antd';
import { ArrowRightOutlined } from '@ant-design/icons';
import { sendContactEmail } from '@/api/contact';
import { useUiStore } from '@/store/useUiStore';

export default function NewsletterForm() {
  const { message } = AntdApp.useApp();
  const [isSending, setIsSending] = useState(false);

  // newsletterEmail 放在 Zustand 中，方便未来在多个页面或弹窗中复用同一份输入状态。
  const newsletterEmail = useUiStore((state) => state.newsletterEmail);
  const setNewsletterEmail = useUiStore((state) => state.setNewsletterEmail);
  const resetNewsletter = useUiStore((state) => state.resetNewsletter);

  async function handleFinish() {
    if (!newsletterEmail) {
      message.error('Please enter an email address.');
      return;
    }

    setIsSending(true);

    try {
      await sendContactEmail(newsletterEmail);
      message.success('Email sent.');
      resetNewsletter();
    } catch (error) {
      message.error(error?.response?.data?.message || 'Failed to send email.');
    } finally {
      setIsSending(false);
    }
  }

  return (
    <section className="newsletter-section">
      <h2 className="newsletter-title">Stay</h2>
      <Form className="newsletter-form" onFinish={handleFinish}>
        <Input
          type="email"
          placeholder="Email"
          value={newsletterEmail}
          onChange={(event) => setNewsletterEmail(event.target.value)}
          required
          aria-label="Email"
        />
        <Button
          htmlType="submit"
          aria-label="Subscribe"
          icon={<ArrowRightOutlined />}
          loading={isSending}
        />
      </Form>
    </section>
  );
}
